import { useState, useEffect, useRef } from 'react'
import { Tabs } from './tabs'
import { EmailInput, Input, PasswordInput } from './form-widgets'
import { nl2br } from '../helpers/nl2br'

export const Login = ({
  loginUrl,
  passwordResetUrl,
  registrationUrl,
  csrfTokens,
  labels,
  title = '',
  errorMessage = '',
}) => {
  const [loginMethod, setLoginMethod] = useState('password')
  const [isCodeSent, setIsCodeSent] = useState(false)
  const errorRef = useRef(null)
  const sendCode = async (event) => {
    event.preventDefault()
    const response = await fetch(loginUrl, {
      method: 'POST',
      body: new FormData(event.currentTarget),
      credentials: 'same-origin',
    })

    if (response.ok) {
      setIsCodeSent(true)
    }
  }

  useEffect(() => {
    if (errorMessage && errorRef.current) {
      errorRef.current.tabIndex = 0
      errorRef.current.focus()
    }
  }, [errorMessage])

  return (
    <>
      <h2 className="login-modal__title">{nl2br(title) || labels.title}</h2>
      <h3 className="login-modal__subtitle h5">{labels.subtitle}</h3>
      <p className="login-modal__required">{labels.required}</p>
      <Tabs
        value={loginMethod}
        onChange={setLoginMethod}
        items={[
          { value: 'password', label: labels.passwordTab },
          { value: 'code', label: labels.codeTab },
        ]}
      />
      <p
        ref={errorRef}
        className="login-modal__error"
        role={'alert'}
        aria-live={'polite'}
      >
        {errorMessage}
      </p>
      {loginMethod === 'password' ? (
        <form method="post" action={loginUrl} className="login-modal__form">
          <input
            type="hidden"
            name="user_login[_token]"
            value={csrfTokens.password}
          />
          <EmailInput
            id="login-email"
            name="user_login[email]"
            label={labels.email}
            required
            inputProps={{ autoComplete: 'email' }}
          />
          <PasswordInput
            id="login-password"
            name="user_login[password]"
            label={labels.password}
            required
            inputProps={{ autoComplete: 'current-password' }}
          />
          <p className="login-modal__link">
            {labels.forgotPassword}{' '}
            <a href={passwordResetUrl}>{labels.resetPassword}</a>
          </p>
          <button
            type="submit"
            name="user_login[submit]"
            className="btn btn--black btn--sm"
          >
            {labels.submit}
          </button>
        </form>
      ) : (
        <div className="login-modal__form">
          <form onSubmit={sendCode}>
            <input
              type="hidden"
              name="user_login_email[_token]"
              value={csrfTokens.email}
            />
            <EmailInput
              id="login-code-email"
              name="user_login_email[email]"
              label={labels.email}
              required
              inputProps={{ autoComplete: 'email' }}
            />
            <button
              type="submit"
              name="user_login_email[submit]"
              className="btn btn--pink"
            >
              {labels.sendCode}
            </button>
          </form>
          {isCodeSent && (
            <form method="post" action={loginUrl}>
              <input
                type="hidden"
                name="user_login_code[_token]"
                value={csrfTokens.code}
              />
              <Input
                id="login-code"
                name="user_login_code[code]"
                label={labels.code}
                required
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]{6}',
                  maxLength: 6,
                }}
              />
              <button
                type="submit"
                name="user_login_code[submit]"
                className="btn btn--black"
              >
                {labels.submit}
              </button>
            </form>
          )}
        </div>
      )}
      <p className="login-modal__link">
        {labels.noAccount} <a href={registrationUrl}>{labels.register}</a>
      </p>
    </>
  )
}
